import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DatePipe } from '@angular/common';
import { InterestpaymentsService } from "../shared/interestpayments.service";
import { SavingsService } from "../shared/savings.service";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

@Component({
  selector: 'app-interestpayments',
  templateUrl: './interestpayments.component.html',
  styleUrls: ['./interestpayments.component.css']
})
export class InterestpaymentsComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  PaymentTypeList: [''];
  BankList: [''];
  DepositsList: [''];

  InterestpaymentsNo: number;
  Address: string;
  AppicationDate: string;
  Scheme: string;
  MaturityDate: string;
  Interest: string;
  SavingsBalance: number;
  CustomerName: string;

  constructor(public interestpaymentsService: InterestpaymentsService,
    public savingsService: SavingsService,
    private commonmastersService: CommonmastersService,
    private router: Router, private route: ActivatedRoute,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.InterestpaymentsNo = +  params['Id'];  // (+) converts string 'id' to a number
    });

    this.FetchDepositNoList()
    this.GetPaymentTypeList();
    this.GetBankList();
    this.resetForm();
    if (Number.isNaN(this.InterestpaymentsNo)) {
      this.interestpaymentsService.selectedInterestPayments.Id = 0;
      this.interestpaymentsService.selectedInterestPayments.Flag = 1;
      this.interestpaymentsService.selectedInterestPayments.IsActive = 1;
      this.AddButtonText = "Save";
    }
    else {
      this.interestpaymentsService.selectedInterestPayments.Id = +this.InterestpaymentsNo;
      this.interestpaymentsService.selectedInterestPayments.Flag = 2;
      this.interestpaymentsService.selectedInterestPayments.IsActive = 1;
      this.AddButtonText = "Edit & Save";

      this.GetSavingsPaymentsBypaymentsNo();
    }

    this.GetAutogeneratedNumber();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.interestpaymentsService.selectedInterestPayments = {
      Id: 0,
      PaymentNo: 0,
      SavingsId: 0,
      CustomerName: null,
      PaymentDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      PaymentTypeId: 0,
      PaymentBankId: 0,
      ChequeNo: null,
      PrincipleAmount: null,
      InterestAmount: null,
      TotalAmount: null,
      Remarks: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: new Date(),
      ModifiedDate: new Date(),
      IsActive: null,
      Flag: null
    }
  }

  public changeDepositNo(SavingsId) {

    for (var i = 0; i < this.DepositsList.length; i++) {

      if (this.DepositsList[i]["Id"] == SavingsId) {
        // this.Address = this.DepositsList[i]["Address"];
        // this.AppicationDate =  this.DepositsList[i]["CreatedDate"];
        this.AppicationDate = this.datePipe.transform(this.DepositsList[i]["CreatedDate"], 'dd/MM/yyyy')
        this.Scheme = this.DepositsList[i]["SchemeName"];
        // this.MaturityDate = this.DepositsList[i]["MaturityDate"];
        this.MaturityDate = this.datePipe.transform(this.DepositsList[i]["MaturityDate"], 'dd/MM/yyyy');
        this.Interest = this.DepositsList[i]["InterestPrecentage"] + '%';
        this.SavingsBalance = this.DepositsList[i]["SavingsBalance"];
        this.CustomerName = this.DepositsList[i]["CustomerName"];
        this.Address = this.DepositsList[i]["CustomerAddress"];
      }
    }
  }

  onSubmit(form: NgForm) {

    if (form.value.SavingsId != null) {
      this.interestpaymentsService.IUDInterestPayments(form.value)
        .toPromise()
        .then(data => {
          // this.resetForm(form);
          this.router.navigate(['/interestpaymentslist']);
          // this.interestpaymentsService.FetchInterestPaymentsList();
        })
        .catch(err => { console.log(err) });
    }
  }

  GetSavingsPaymentsBypaymentsNo() {
    if (this.interestpaymentsService.selectedInterestPayments.Id !== 0) {

      this.interestpaymentsService.FetchInterestPaymentsById(this.interestpaymentsService.selectedInterestPayments)
        .subscribe(data => {
          this.interestpaymentsService.selectedInterestPayments = data;
          this.interestpaymentsService.selectedInterestPayments.Flag = 2;

          this.changeDepositNo(data.SavingsId);
        })
    }
  }

  FetchDepositNoList() {
    this.interestpaymentsService.FetchDepositNoList().subscribe(data => {
      this.DepositsList = data;
    })
  }

  GetPaymentTypeList() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentTypeList = data;
    })
  }

  GetBankList() {
    this.commonmastersService.FetchBankList().subscribe(data => {
      this.BankList = data;
    })
  }

  GetAutogeneratedNumber(): any {
    if (this.interestpaymentsService.selectedInterestPayments.Id === 0) { // Parent Loan No number checks
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.interestpaymentsService.selectedInterestPayments.PaymentNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    // else {
    //   this.interestpaymentsService.selectedInterestPayments.PaymentNo = + this.InterestpaymentsNo;
    // }
  }

}
